module.exports = __webpack_public_path__ + "static/media/arrow-up-orange.74b1da90.svg";